import { createStaffCustomerMemoryApi } from "@lafayette/api-client";

import { currentAccessToken } from "../catalog/admin-runtime";
import { getAdminPublicConfig } from "../config/public-config";
import type { MemoryRuntime } from "./runtime";

/**
 * The runtime of the real admin app: the typed client over `fetch` and the clock. The bearer token comes
 * from the same function the catalog uses, so the development token stays behind the one
 * `import.meta.env.DEV` branch.
 */
export function createAdminMemoryRuntime(): MemoryRuntime {
  const config = getAdminPublicConfig();
  return {
    api: createStaffCustomerMemoryApi({
      baseUrl: config.apiUrl.toString(),
      getAccessToken: currentAccessToken,
    }),
    now: () => new Date(),
  };
}
